import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { getCardImages } from '../redux';
import { getCardColorInfoList } from 'src/universal/redux/cardColors';

import { decideCardArtUrl } from 'src/universal/utils/cardColorChoices';

import styles from '../__styles__/stickyMobileHeader.scss?modules';

const StickyHeader = ({ shouldRender, cardImages, cardColorInfoList }) => {
  return (
    <div
      className={clsx(styles.stickyHeader, {
        [styles.shouldRender]: shouldRender
      })}
    >
      {cardImages.map(({ cardArt, altText, learnMoreSrc, shortName }, i) => {
        const colorInfo = cardColorInfoList.find(
          item => item.shortName === shortName
        );
        const cardArtUrl = decideCardArtUrl(cardArt ?? '', colorInfo, shortName);
        return (
          <div className={styles.flexItem} key={`${altText}_${i}`}>
            {cardArt && altText ? (
              <a href={learnMoreSrc} aria-label={`Learn More about ${altText}`}>
                <img src={cardArtUrl} alt={altText} />
              </a>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state, { selectedCards }) => {
  return {
    cardColorInfoList: getCardColorInfoList(state),
    cardImages: getCardImages(state, selectedCards)
  };
};

export default connect(mapStateToProps)(StickyHeader);
